import DOMPurify from 'dompurify';

export function sanitizeBasicHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['b', 'i', 'br', 'p', 'strong', 'ol', 'ul', 'li'],
    ALLOWED_ATTR: [],
  });
}
